module.exports = __webpack_public_path__ + "img/balance-fail.16d59b62.svg";